import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import axios from "axios";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import {
  Box,
  Stack,
  TextField,
  Paper,
  Grid,
  IconButton,
  Modal,
  Typography,
  Button,
  LinearProgress,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/lab/";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { makeStyles } from "@material-ui/core";
import * as MdIcons from "react-icons/md";
import { fr } from "date-fns/locale";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
  },
  toolbar: {
    height: "64px",
  },
  paperDate: {
    width: "500px",
    height: "250px",
    [theme.breakpoints.down("md")]: {
      paddingRight: "30px",
      height: "280px",
      width: "400px",
    },
  },
  boxDate: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "20px",
    paddingTop: "20px",
  },
  paperDownload: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 60,
  },
  paperDesign: {
    borderRadius: "10px !important",
    padding: "20px",
    height: "250px",
    width: "650px",
    [theme.breakpoints.down("md")]: {
      height: "280px",
      marginTop: 20,
      width: "400px",
      height: "400px",
    },
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "51px",
    height: "51px",
  },
}));
function MonthlyReport(props) {
  const classes = useStyles();

  const [monthlyDate, setMonthlyDate] = useState(null);
  const [yearState, setYearState] = useState(null);
  const [monthState, setMonthState] = useState(null);
  const [openFailed, setOpenFailed] = useState(false);
  const [monthWritten, setMonthWritten] = useState(null);
  const [monthlyTransac, setMonthlyTransac] = useState([]);
  const [monthlyTransacFailed, setMonthlyTransacFailed] = useState([]);
  //const [moneyOut, setMoneyOut] = useState([]);
  const [amountWires, setAmountWires] = useState(0);
  const [totalCa, setTotalCa] = useState(null);
  const [referrals, setReferrals] = useState(null);
  const [loading, setLoading] = useState(true);
  const [stopReqMoneyOut, setStopReqMoneyOut] = useState(false);
  const [loadWires, setLoadWires] = useState(true);
  const [openWait, setOpenWait] = useState(false);

  let tokenStorage = null;
  let monthlyRecord = [];
  let monthlyRecordFail = [];
  let moneyOutRecord = [];
  let year = null;
  let month = null;
  let refEarnings = [];
  let page = 1;
  let wires = [];
  let moneyOutRecNextMonth = [];

  const today = new Date();

  useEffect(() => {
    todaysDate();
    // reqMonthlyXls();
  }, []);

  const todaysDate = () => {
    year = today.getYear() + 1900;
    month = String(today.getMonth() + 1).padStart(2, "0");
    setMonthState(month);
    setYearState(year);
    setMonthWritten(today.toLocaleString("fr", { month: "long" }));
  };

  const downloadMonthlyXls = async () => {
    setLoading(true);
    setOpenWait(true);
    await axios
      .get(
        `https://bck-aix-en-provence.carloapp.com/api/business/my_monthly_report?date=${yearState}-${monthState}-01`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      )
      .then((res) => {
        setOpenWait(false);
        setLoading(false);
        // const blog = res.data;
        // if (blog.type === "application/json") {
        //   setOpenFailed(true);
        // } else {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${monthState}-${yearState}.xls`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        // }
      });
  };

  const monthlyTransactions = (newDate) => {
    //setLoading(true);
    setLoadWires(true);
    setAmountWires(0);
    setMonthlyTransac([]);
    setMonthlyTransacFailed([]);
    setStopReqMoneyOut(false);
    setOpenFailed(false);
    //setMoneyOut([]);
    month = String(newDate.getMonth() + 1).padStart(2, "0");
    // need to add 1900 because the method .getYear() in JS removes 1900 to the data
    year = newDate.getYear() + 1900;
    setMonthWritten(newDate.toLocaleString("fr", { month: "long" }));
    setMonthlyDate(newDate);
    setMonthState(month);
    setYearState(year);
  };

  const reqMonthlyXls = async () => {
    await axios
      .get(
        `https://bck-aix-en-provence.carloapp.com/api/business/my_monthly_report?date=${year}/${month}/01`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      )
      .then((res) => {
        const blog = res.data;
        if (blog.type === "application/json") {
          setOpenFailed(true);
          setOpenWait(false);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${monthState}-${yearState}.xls`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          setOpenWait(false);
        }
      });
  };

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ flexGrow: 1, display: "flex" }}>
      <ResponsiveDrawer />

      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        <Box ml={2}>
          <h2>Rapport mensuel</h2>

          <Grid container>
            <Grid item xs={12} lg={5}>
              <Paper
                className={classes.paperDate}
                sx={{ borderRadius: "10px" }}
              >
                <Box className={classes.boxDate}>
                  <h3>Télécharger votre rapport mensuel</h3>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={fr}
                  >
                    <Stack direction="row" spacing={2}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={fr}
                      >
                        <Stack className={classes.stack}>
                          <DatePicker
                            inputFormat="MM-yyyy"
                            openTo="month"
                            views={["year", "month"]}
                            label="Choisir un mois"
                            minDate={new Date("2021-01-01")}
                            maxDate={new Date()}
                            value={monthlyDate}
                            onChange={() => console.log()}
                            onMonthChange={(newDate) => {
                              monthlyTransactions(newDate);
                            }}
                            // onClose={monthlyTransactions}
                            renderInput={(params) => (
                              <TextField {...params} helperText={null} />
                            )}
                          />
                        </Stack>
                      </LocalizationProvider>{" "}
                      <Paper
                        className={classes.paperDownload}
                        sx={{ backgroundColor: "#006EFF" }}
                      >
                        <IconButton onClick={downloadMonthlyXls}>
                          <MdIcons.MdOutlineFileDownload color="white" />
                        </IconButton>
                      </Paper>
                    </Stack>
                  </LocalizationProvider>
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} lg={7}>
              <Paper className={classes.paperDesign}>
                <Typography
                  mt={1}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  Retrouver vos rapports mensuels seulement en quelques clics :
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Choisissez le mois que vous désirez
                    </Typography>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Cliquez sur l'icône de téléchargement
                    </Typography>
                    <Typography mt={1} sx={{ fontSize: "16px" }}>
                      - Retrouvez directement votre rapport mensuel sur votre
                      ordinateur
                    </Typography>
                  </Box>
                  <Box
                    mt={3}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      alt="Component"
                      src="/payment_request_illustration.png"
                      sx={{ width: "160px" }}
                      mr={5}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {/* Modal to show progress/wait */}
        <Modal open={openWait}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <LinearProgress />
          </Box>
        </Modal>
        {/* Modal to show no daily report exists */}

        <Modal open={openFailed}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <IconButton color="error" className={classes.icon}>
              <MdIcons.MdError className={classes.icon} />
            </IconButton>
            <Typography mb={2}>
              Vous n'avez pas effectué de transaction ou reçu de gain parrainage
              ce jour.
            </Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenFailed(false)}
            >
              Fermer
            </Button>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyReport);
